import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../components/AdminLayout";
import api from "../../services/api";
import { FiUsers, FiMessageSquare, FiVideo, FiList } from "react-icons/fi";


const Dashboard = () => {
  const [stats, setStats] = useState({
    lifeSavers: 0,
    communications: 0,
    videos: 0,
    statusEntries: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [lifeSaversRes, communicationsRes, videosRes, statusRes] =
        await Promise.all([
          api.get("/life-savers").catch(() => ({ data: [] })),
          api.get("/communications/admin").catch(() => ({ data: [] })),
          api.get("/videos/admin").catch(() => ({ data: [] })),
          api.get("/dashboard-status/admin").catch(() => ({ data: [] })),
        ]);

      setStats({
        lifeSavers: lifeSaversRes.data?.length || 0,
        communications: communicationsRes.data?.length || 0,
        videos: videosRes.data?.length || 0,
        statusEntries: statusRes.data?.length || 0,
      });
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="spinner"></div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="page-header">
        <h1 className="page-title">Admin Dashboard</h1>
      </div>

      <div className="dashboard-grid">
        <div className="stat-card">
          <div className="stat-card-header">
            <div>
              <div className="stat-card-value">{stats.lifeSavers}</div>
              <div className="stat-card-label">Total Members</div>
            </div>
            <div className="stat-card-icon blue">
              <FiUsers />
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card-header">
            <div>
              <div className="stat-card-value">{stats.communications}</div>
              <div className="stat-card-label">Communications</div>
            </div>
            <div className="stat-card-icon green">
              <FiMessageSquare />
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card-header">
            <div>
              <div className="stat-card-value">{stats.videos}</div>
              <div className="stat-card-label">Videos</div>
            </div>
            <div className="stat-card-icon orange">
              <FiVideo />
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-card-header">
            <div>
              <div className="stat-card-value">{stats.statusEntries}</div>
              <div className="stat-card-label">Status Entries</div>
            </div>
            <div className="stat-card-icon purple">
              <FiList />
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Quick Actions</h2>
        </div>
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
          <Link to="/admin/life-savers" className="btn btn-primary">
            <FiUsers style={{ marginRight: "0.5rem" }} />
            Manage Members
          </Link>
          <Link to="/admin/communications" className="btn btn-success">
            <FiMessageSquare style={{ marginRight: "0.5rem" }} />
            Post Communication
          </Link>
          <Link to="/admin/videos" className="btn btn-secondary">
            <FiVideo style={{ marginRight: "0.5rem" }} />
            Manage Videos
          </Link>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;
